// extracted by mini-css-extract-plugin
module.exports = {"arrow":"j7","dropMenu":"j8","dropMenuInner":"j9","itemborder":"j-","dropDownCurrent":"j_","menuItem":"ka","langContainer":"kb","current":"kc","outlink":"kd"};